module.exports = __webpack_public_path__ + "static/media/AB_O1_8.a14e1321.jpg";